module.exports = __webpack_public_path__ + "img/link02.cbe4bbc1.png";